import PropTypes from 'prop-types'
import React from 'react'

import AddAndGoToCart from 'containers/AddAndGoToCart'
import { Button } from 'shared/Button'

import {
  Root,
  Photo,
  Content,
  Title,
  Description,
  PriceRow,
  Price,
} from './styles'

/**
 * Баннер-связка «Созданы друг для друга».
 * Цена приходит из goods['_bundle'] (dna + biome), кнопка кладёт в корзину оба теста.
 */
const BundleLayout = ({
  title,
  description,
  currentPrice,
  buttonPurchaseText,
  mobile,
  isZeroPrice,
}) => {
  return (
    <Root>
      <Photo />

      <Content>
        <Title
          forwardedAs='h1'
          weight='medium'
          size={['65/70', '50/60', '30/34']}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {description && (
          <Description
            forwardedAs='p'
            size={['18/28', '18/28', '16/22']}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </Content>

      <PriceRow>
        {currentPrice && (
          <Price
            weight='medium'
            size={['35/40', '35/40', '25/30']}
          >
            {currentPrice}
          </Price>
        )}

        <AddAndGoToCart
          goods={[
            { type: 'dna', isSubscription: false },
            { type: 'biome', isSubscription: false },
          ]}
          buttonProps={{
            color: 'white',
            size: mobile ? 'mobile' : 'desktop',
            disabled: isZeroPrice,
          }}
          ButtonComponent={Button}
          forceMultipleAdd
        >
          {buttonPurchaseText}
        </AddAndGoToCart>
      </PriceRow>
    </Root>
  )
}

BundleLayout.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  currentPrice: PropTypes.string,
  buttonPurchaseText: PropTypes.string.isRequired,
  mobile: PropTypes.bool,
  isZeroPrice: PropTypes.bool,
}

export default BundleLayout
